var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"sm":"8","offset-sm":"2","md":"6","offset-md":"3","lg":"4","offset-lg":"4"}},[_c('v-card',{staticClass:"elevation-12",attrs:{"color":"primary"}},[_c('div',{staticClass:"logo"},[_c('img',{staticClass:"logoImg",attrs:{"src":_vm.logos.logo}})]),_c('login-form')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }